<template>
  <div eagle-form-item="offset"></div>
</template>

<script>
import formItemMixin from '@/components/form/mixins/formItemMixin'
export default {
  mixins: [formItemMixin],
}
</script>

<style lang="sass" type="text/sass" scoped></style>
